import { format, parse } from 'date-fns';
import { DateFormats } from 'infrastructure/enums';

export const formatTime = (time?: number) => {
  if (time && !Number.isNaN(time)) {
    const minutes = Math.floor(time / 60);
    const formatMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const seconds = Math.floor(time % 60);
    const formatSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${formatMinutes}:${formatSeconds}`;
  }
  return '00:00';
};

/**
 *
 * @param time 10:00:00
 * @returns 10:00 AM
 */
export const convert24TimeTo12 = (time: string) => {
  return format(
    parse(time, DateFormats['HH:mm:ss'], new Date()),
    DateFormats['h:mm a'],
  );
};
